import { InputModelsComponent } from './components/input-models/input-models.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { CalculatorGuard } from './pages/calculator/guard/calculator.guard';
import { AuthGuard } from './guards/auth-guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'prefix',
  },
  {
    path: 'input-models',
    component: InputModelsComponent,
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home-logged/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro',
    loadChildren: () =>
      import('./pages/cadastro/cadastro.module').then((m) => m.CadastroModule),
  },
  {
    path: 'contratacao',
    loadChildren: () =>
      import('./pages/logged-in-contracting/logged-in-contracting.module').then(
        (m) => m.LoggedInContractingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'calculadora',
    loadChildren: () =>
      import('./pages/calculator/calculator.module').then(
        (m) => m.CalculatorModule
      ),
    resolve: { data: CalculatorGuard },
  },
  {
    path: 'resultados',
    loadChildren: () =>
      import('./pages/results/results.module').then((m) => m.ResultsModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'formalizacao',
    loadChildren: () =>
      import('./pages/formalization/formalization.module').then(
        (m) => m.FormalizationModule
      ),
  },
  {
    path: 'revisao',
    loadChildren: () =>
      import('./pages/revision-data/revision-data.module').then(
        (m) => m.RevisionDataModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'contratos',
    loadChildren: () =>
      import('./pages/contracts/contracts.module').then(
        (m) => m.ContractsModule
      ),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]

})
export class AppRoutingModule {}
